import { applyStoredColorScheme } from '@myosh/design-system';
import { TooltipProvider } from '@myosh/odin-components';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import App from './App';
import '@myosh/odin-translations/i18n';
import './index.css';
import store from './redux/store';
import reportWebVitals from './reportWebVitals';

applyStoredColorScheme();

const root = createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <TooltipProvider>
        <App />
      </TooltipProvider>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
